// imports
import Accordion from './Accordion';

// private statics

// class definition
export default class CTAccordion extends Accordion {
    // constructor
    constructor (args = {}, objectName = 'Accordion') {
        args.debug = args.debug || false;
        args.preventDefault = true;

        // super
        super(args, objectName);
    }

    // methods
    destroy () {
        super.destroy();
    }

    // getters & setters
}

// Utils

// Event handlers
